module.exports = __webpack_public_path__ + "media/components/src/assets/images/method/diners-24021d1d8b5069766cd5b3396223d9ca.png";